import React, { useEffect, useState } from 'react'
import classNames from 'classnames';
import './index.scss'
import { KEYBORD_DATA } from './config'
// import Button from '../Button'

interface IProps {
  initPlateNumber?: string
  onConfirm: (plateNum) => void
}

export default function PlateKeyboardV2({
  initPlateNumber = '',
  onConfirm,
}: IProps) {
  const [plateNumber, setPlateNumber] = useState<string[]>([])
  const blankPlaceholder = new Array(8).fill('')

  useEffect(() => {
    if (initPlateNumber?.length === 7 || initPlateNumber?.length === 8) {
      setPlateNumber(initPlateNumber.split(''))
    }
  }, [initPlateNumber])

  const handlePressLetter = (letter: string) => {
    if (plateNumber.length >= 8) return
    setPlateNumber([...plateNumber, letter])
  }

  // 删除键
  const handlePressDelete = () => {
    if (plateNumber.length > 0 && plateNumber.length <= 8) {
      const newPlateNUmber = plateNumber.slice(0, -1)
      setPlateNumber(newPlateNUmber)
    }
  }

  // 完成键
  const handlePressCommit = () => {
    if (plateNumber?.length !== 7 && plateNumber?.length !== 8) return;
    onConfirm(plateNumber.join(''))
  }

  return (
    <div className="plate-keyboard-container">
      <div className={"plateContainer"}>
        {
          blankPlaceholder.map((_, index) => {
            return index === 1 ? (
              <div
                className={"letterItemWithPad"}
                key={`plate_letter_${index}`}
              >
                <div
                  className={classNames("letterItem", {
                    'letter-item-typing': index === plateNumber.length - 1
                  })}
                >
                    {plateNumber[index]}
                  </div>
                <div className={"pointPad"}>
                  <div className={"pad"}></div>
                </div>
              </div>
            ) : (
              <div
                className={classNames("letterItem", {
                  'letter-item-typing': index === plateNumber.length - 1
                })}
                key={`plate_letter_${index}`}
              >
                {
                  plateNumber[index]
                }
              </div>
            )
          })
        }
      </div>
      <div className="plate-tips">
        *请勿输入临时车牌号码
      </div>
      <div className={"keyboardContainer"}>
        {
          plateNumber.length === 0 ? (
            <div className={"letterContainer"}>
              {
                KEYBORD_DATA.province.map((letter) => {
                  return (
                    <div className={"letterItem"} key={letter}>
                      <div
                        className={"letter"}
                        onClick={() => handlePressLetter(letter)}
                      >
                        {letter}
                      </div>
                    </div>
                  )
                })
              }
              
              <div className={"deleteBtnContainer"}>
                <div
                  className={[
                    "deleteBtn",
                    plateNumber?.length === 0 ? "disabled" : '',
                  ].join(' ')}
                  onClick={handlePressDelete}
                >
                  <i className="delete-icon" />
                </div>
              </div>
            </div>
          ) : (
            <div className={"letterContainer"}>
              {KEYBORD_DATA.letters.map((letter) => {
                return (
                  <div className={"letterItem"} key={letter}>
                    {letter === 'I' || letter === 'O' ? (
                      <div className={["letter", "disabled"].join(' ')}>
                        {letter}
                      </div>
                    ) : (
                      <div
                        className={"letter"}
                        onClick={() => handlePressLetter(letter)}
                      >
                        {letter}
                      </div>
                    )}
                  </div>
                )
              })}
              {
                KEYBORD_DATA.letters.length % 6 === 0 && (
                  <div className="letter-place-holder" />
                )
              }
              <div className={"deleteBtnContainer"}>
                <div
                  className={[
                    "deleteBtn",
                    plateNumber?.length === 0 ? "disabled" : '',
                  ].join(' ')}
                  onClick={handlePressDelete}
                >
                  <i className="delete-icon" />
                </div>
              </div>
            </div>
          )
        }
        
      </div>
      {/* <Button
        disabled={plateNumber?.length !== 7 && plateNumber?.length !== 8}
        fixed={true}
        onClick={handlePressCommit}
      >
        <span>完成添加</span>
      </Button> */}
      <div className="action-field">
        <div
          className={classNames("confirm-btn", {
            'btn-disabled': plateNumber?.length !== 7 && plateNumber?.length !== 8
          })}
          onClick={handlePressCommit}
        >
          完成添加
        </div>
      </div>
    </div>
  )
}
